export default {
  'CLICK-BTN-REPACKAGEPRINT-PRINT-TYPE': {
    key: 'click-btn-rePackagePrint-print-type',
    label: '点击-单据打印-打印-类型'
  }
}